// removed by extract-text-webpack-plugin
module.exports = {"theme":"#3B82F6"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/styles/element-variables.scss
// module id = a77Z
// module chunks = 8